import { RecentWinnersResponse } from 'types/types'
import { BEAPIClient, handleResponseSuccess } from './BEClient'

const SOCIAL_PROOF_ENDPOINTS = {
  GET_RECENT_WINNERS: (partnerId: string | number) =>
    `/games/v1/partners/${partnerId}/recent-winners`,
}

export const socialProofApi = {
  /**
   * GET /games/v1/partners/{partner_id}/recent-winners
   * Fetch recent winners and the active players count for the homepage social proof banner.
   */
  getRecentWinners: async (partnerId: string | number) => {
    try {
      const response = await BEAPIClient.get<RecentWinnersResponse>(
        SOCIAL_PROOF_ENDPOINTS.GET_RECENT_WINNERS(partnerId),
      )
      return handleResponseSuccess(response)
    } catch (error) {
      throw new Error(`Failed to fetch recent winners for partner ${partnerId}: ${error}`)
    }
  },
}
